<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="item in logDatas" :label="item.sysName" :name="item.sysName">
        <el-timeline>
          <el-timeline-item v-for="item in item.updateLog" :color="item.size === 'large' ? '#409EFF': '#e4e7ed'" :size="item.size"
                            :timestamp="item.updateTime" placement="top" >
            <el-card>
              <h4><i class="el-icon-message-solid" style="color: #337ecb"></i>  更新:</h4>
              <ul>
                <template v-if="item?.contentArr?.length>0">
                  <li  class="logDetail" v-for="(itemInner,index) in item?.contentArr">
                  <span v-if="typeof itemInner==='object'">
                    <span style="font-size: 15px;color: #2c81d9">{{ itemInner.title }}：</span>
                    <ul>
                      <li v-for="(item,i) in itemInner.content" style="line-height: 32px;font-size: 14px">
                        <i class="iconfont icon-dian"></i>{{ i + 1 }}、<span v-html="item"></span>
                        <a  v-if="itemInner.link&&i===0" :href="itemInner.link"
                            target="_blank" style="margin-left: 5px">
                          <i class="el-icon-info" style="color: orange"></i>查看更多详情
                        </a>
                      </li>
                    </ul>
                  </span>
                  </li>
                </template>
                <template v-else >
                  <li  v-for="(itemInner,index) in item?.content" style="line-height: 30px;font-size: 15px">
                    <i class="iconfont icon-dian"></i>{{ index + 1 }}、{{ itemInner }}</li>
                </template>


                <br>
              </ul>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </el-tab-pane>
    </el-tabs>

  </div>

</template>

<script>

import {getLogData} from "@/utils/data/basicData/log";

export default {
  name: 'Log',
  data() {
    return {
      logDatas:getLogData().filter(item=>!item.isNoCustomer||(item.isNoCustomer&&this.$store.getters["right/getRole"]!=='USER')),
      activeName:'多样性交付系统',
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

h3 {
  margin-top: 0;
  font-size: 25px;
}
h4 {
  font-size: 16px;
}

</style>
